import { connectHits } from 'instantsearch.js/es/connectors';
import modal from '../../modal';

// create the render function
const renderHitsTable = (renderOptions) => {
    const {
        hits,
        widgetParams,
    } = renderOptions;

    if (hits.length === 0) {
        widgetParams.container.innerHTML = '';
        return;
    }

    if (hits.length > 9) {
        const searchResults = document.querySelector('.js-psearch-results-wrap');
        searchResults.classList.add('has-overflow', 'after:!content-[""]');
    }

    widgetParams.container.innerHTML = `
        <table>
            <thead>
                <tr>
                    <th class="pt-0 pb-3 whitespace-nowrap">Section</th>
                    <th class="pt-0 pb-3 whitespace-nowrap">Profile</th>
                    <th class="pt-0 pb-3 whitespace-nowrap">Rim</th>
                    <th class="pt-0 pb-3 whitespace-nowrap">Load</th>
                    <th class="pt-0 pb-3 whitespace-nowrap">Speed</th>
                    <th class="pt-0 pb-3 whitespace-nowrap">EAN</th>
                    <th class="pt-0 pb-3 whitespace-nowrap"></th>
                </tr>
            </thead>
            <tbody>
                ${hits.map((item) => `
                    <tr>
                        <td class="py-3 text-center">${item.section}</td>
                        <td class="py-3 text-center">${item.profile}</td>
                        <td class="py-3 text-center">${item.rim}</td>
                        <td class="py-3 text-center">${item.load}</td>
                        <td class="py-3 text-center">${item.speed}</td>
                        <td class="py-3 text-center">${item.ean}</td>
                        <td class="py-3 text-center" data-id="${item.tyeprelid}">
                            ${item.tyeprelid === 'POR' ? `
                                <button
                                    class="underline js-modal"
                                    data-modal="port">POR tyre</button>
                            ` : `
                                ${item.tyeprelid > 0 ? `
                                    <button
                                        class="underline whitespace-nowrap js-modal"
                                        data-modal="eu-tyre-rating"
                                        data-class="eu-rating-modal"
                                        data-tyeprelid="${item.tyeprelid}"
                                        ${item.product_information_sheet !== '' ? `data-product-information-sheet="${item.product_information_sheet}"` : ''}>EU tyre label</button>
                                ` : ''}
                            `}
                        </td>
                    </tr>
                `).join('')}
            </tbody>
        </table>
    `;

    // init modal links
    modal();
};

// create the custom widget
const customHitsTable = connectHits(renderHitsTable);

export default customHitsTable;
